import {createApp} from 'vue';
import AppWrapper from './AppWrapper.vue';
import router from './router';
import store from "./store";

import '@/assets/styles/layout.scss';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import i18n from './i18n';

import Pagination from './components/Pagination';
import Code from './service/code/Code';
import ChaAlert  from './components/ChaAlert';
import VueLoading from 'vue-loading-overlay';

// const messages = Object.assign(languages)

// const i18n = createI18n({
//     legacy: false,
//     locale: defaultLocale,
//     fallbackLocale: defaultLocale,
//     messages
// })

const app = createApp(AppWrapper)
    .use(i18n)
    .use(store)
    .use(router)
    .use(Pagination)
    .use(ChaAlert)
    .use(VueLoading)
    .provide('i18n', i18n)
    .provide('Code', Code);

// COMMA
app.config.globalProperties.$filters = {
  comma(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

app.mount("#app");